/**
 * Lot Renderer Service
 *
 * Builds the `lotRenderer` adapter object that wires site-plan lot domain logic
 * into the generic `svgOverlays` facade via the `handlers.lotRenderer` slot.
 *
 * This is the only file that imports from both the lot domain (sitePlanLots,
 * lotPolygons) and references the facade contract shape. The library layer
 * (svgOverlays.js) stays free of lot-specific imports.
 *
 * @module searchResultsMap/services/lotRenderer
 */

import {
  sortLayersByOrder,
} from './sitePlanLots';
import renderLotStatusClasses from '../components/lotPolygons';

/**
 * Builds the `lotRenderer` object that `svgOverlays.js` calls for all lot-specific
 * rendering.
 *
 * @param {Object} lotClasses  - CSS class map { active }
 * @returns {Object} lotRenderer — passed into handlers.lotRenderer
 */
export default function buildLotRenderer(lotClasses) {
  return {
    /** Sorts layers by their `order` field before group creation. */
    sortLayers: sortLayersByOrder,

    /** Applies the active class on all lot polygon paths after zoom changes. */
    applyStatusClasses(svgRoot) {
      renderLotStatusClasses(svgRoot, lotClasses.active);
    },
  };
}
